import React from "react";
import "./App.css";
import Testimoni from "./component/Slider/testimoni";
import Panelo from "./component/Slider/panelo";
import Footer from "./component/Footer";

function Home() {
  return (
    <div className="Home">
      <main className="font-nunito select-auto ">
        {/* Jumbotron Section Start Here */}
        <section className="pt-16">
          <div id="jumbotron">
            <img className="w-full" src="./img/carousel.webp" alt="" />
          </div>
          <h2 className="text-heading-color font-semibold text-2xl mt-10 lg:mb-20 text-center p-4">
            Panelo help digital transformation at respectable organization:
          </h2>
          <ul className="flex justify-center items-center">
            <li className="mx-2 lg:mx-7">
              <img src="./img/bni.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/tsm.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/abb.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/danone.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/pwc.png" alt="" />
            </li>
            <li className="mx-2 lg:mx-7">
              <img src="./img/dep-pertanian.png" alt="" />
            </li>
          </ul>
        </section>

        {/* Jumbotron Section End Here */}
        {/* Easy To Use Section Start Here */}

        <section
          id="easy_to_use"
          className="bg-main-color mt-11 flex flex-col justify-center items-center relative"
        >
          <h2 className="text-white text-4xl pt-11 font-bold text-center">
            EASY TO USE
          </h2>
          <div className="flex flex-col lg:flex-row justify-center items-center mt-9 lg:mt-0">
            <div className="left flex flex-col lg:flex-row items-center w-3/12 lg:pr-20 ">
              <img
                className="mb-2 lg:mb-0"
                loading="lazy"
                src="./img/easy-1.png"
                alt=""
              />
              <img loading="lazy" src="./img/social.png" alt="" />
            </div>
            <div className="middle p-12 ">
              <img loading="lazy" src="./img/easy-2.png" alt="" />
            </div>
            <div className="right flex flex-col lg:flex-row items-center w-3/12">
              <img
                className="mb-2 lg:mb-0"
                loading="lazy"
                src="./img/social.png"
                alt=""
              />
              <img loading="lazy" src="./img/hp.png" alt="" />
            </div>
          </div>
          <div className="flex mt-10 lg:absolute bottom-10 lg:bottom-16 right-16">
            <a href="">
              <img
                loading="lazy"
                src="./img/google-play.png"
                alt=""
                className="mr-5 lg:mr-10"
              />
            </a>
            <a href="">
              <img loading="lazy" src="./img/app-store.png" alt="" />
            </a>
          </div>
          <button className="text-white bg-button-banner p-3 mt-6 lg:mt-0  pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-red-900">
            <a href="#">Learn More</a>
          </button>
        </section>
        {/* Easy To Use Section EndHere */}
        {/* Our Solution Section Start Here */}
        <section id="our_solution" className="mt-11">
          <h2 className="text-heading-color text-4xl pt-11 mb-10 font-bold text-center">
            OUR SOLUTION
          </h2>

          <div className="solution flex flex-col lg:flex-row justify-center p-4 lg:p-20 lg:px-28">
            <div className="sign border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5 ">
              <div className="flex flex-col items-center lg:items-stretch">
                <img
                  loading="lazy"
                  src="./img/logo-panelo2.png"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 pr-6 text-xl font-bold text-orange-dark text-right">
                  Sign
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Panelo sign make any screen a Digital Signage, offers premium
                  commercial and interactive digital signage include Kiosk for
                  self service application that impress and draw attention of
                  your visitors with campaign that fully controlled by you.
                  <br /> <br />
                  Our cloud services are remotely accessible, secure and
                  easy-to-use.
                </p>
                <button className="text-white float-left bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Find More</a>
                </button>
              </div>
            </div>
            <div className="cms border-b-2 lg:border-b-0 lg:border-r-2 border-dashed p-5">
              <div className="flex flex-col items-center lg:items-stretch">
                <img
                  loading="lazy"
                  src="./img/logo-panelo2.png"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 pr-6 text-xl font-bold text-orange-dark text-right">
                  CMS
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center">
                <p className="text-left">
                  Any source of content, any kind of Display and no matter how
                  far the display, Panelo CMS provides reliable Content and
                  Display Management solution, to control any digital display
                  using web Management or Mobile Application.
                  <br />
                  <br />
                  With open platform, Panelo CMS easily integrated with other
                  system and IoT to create automatic content and campaign
                  management.
                </p>

                <button className="text-white float-left bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Find More</a>
                </button>
              </div>
            </div>
            <div className="vision p-5">
              <div className="flex flex-col items-center lg:items-stretch">
                <img
                  loading="lazy"
                  src="./img/logo-panelo2.png"
                  className=""
                  alt=""
                />
                <h3 className="font-robotoslab mb-5 pr-6 text-xl font-bold text-orange-dark text-right">
                  Vision
                </h3>
              </div>
              <div className="flex flex-col justify-center items-center ">
                <p className="text-left">
                  Panelo Vision is AI powered system to gather data and know
                  your audience. The data come from people or vehicle
                  surrounding your display. Panelo Vision enable smart Digital
                  Signage that adapt the content within audiences demographic.
                </p>
                <button className="text-white float-left bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                  <a href="#">Find More</a>
                </button>
              </div>
            </div>
          </div>
        </section>
        {/* Our Solution Section End Here */}
        {/* We can Help You With Section Start Here */}
        <section className="mb-16">
          <h2 className="text-heading-color text-4xl pt-11 font-bold text-center">
            WE CAN HELP YOU WITH
          </h2>
          <ul className="flex flex-col lg:flex-row justify-center items-center mt-10 lg:px-28">
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  loading="lazy"
                  width="300px"
                  src="./img/digital-menu.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Digital Menuboard
                </figcaption>
              </figure>
            </li>
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  loading="lazy"
                  width="300px"
                  src="./img/interactive-signage.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Interactive Signage
                </figcaption>
              </figure>
            </li>
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  loading="lazy"
                  width="300px"
                  src="./img/view-analytic.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Viewer Analytic
                </figcaption>
              </figure>
            </li>
          </ul>
          <ul className="flex flex-col lg:flex-row justify-center items-center lg:px-28">
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  loading="lazy"
                  width="300px"
                  src="./img/digital-out.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Digital Out of Home
                </figcaption>
              </figure>
            </li>
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  width="300px"
                  loading="lazy"
                  src="./img/retail-digital.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Retail Digital Signage
                </figcaption>
              </figure>
            </li>
            <li className="mb-7 lg:ml-7">
              <figure className="w-figure relative">
                <img
                  width="300px"
                  loading="lazy"
                  src="./img/kiosk.png"
                  alt=""
                />
                <figcaption className="w-full text-white font-bold bg-desc-color-bg bottom-0 text-center rounded-lg absolute text-3xl p-3">
                  Self Service Kiosk
                </figcaption>
              </figure>
            </li>
          </ul>
        </section>
        {/* We can Help You With Section End Here */}
        {/* Free Templates Section Start Here */}
        <section className="bg-gray-100 pb-16">
          <h2 className="text-heading-color text-4xl pt-11 font-bold text-center mb-12">
            1000+ FREE TEMPLATES
          </h2>

          <div className="templates flex flex-col lg:flex-row xs:px-6 lg:px-28 justify-center items-center">
            <img
              className="lg:w-3/5 mb-5"
              width="300px"
              loading="lazy"
              src="./img/templates-img.png"
              alt="1000+ Free Templates"
            />

            <div className="desc-templates lg:ml-16">
              <p>
                Covid Safety Guidelines :20 <br />
                Digital Menu : 70 <br />
                Holiday & Event : 45 <br />
                Food & Beverage : 100+ <br />
                Health & Medical : 100+ <br />
                Office & Professional Services : 100+ <br />
                Retail, Gyms & Fitness: 57 <br />
              </p>
              <button className="text-white float-left bg-main-color mt-6 p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                <a href="#">Browse Templates</a>
              </button>
            </div>
          </div>
        </section>
        {/* Free Templates Section End Here */}
        {/* Happy Customer Section Start Here */}
        <Testimoni />
        {/* Happy Customer Section End Here  */}
        {/* Blog Section Start Here  */}
        <section className="bg-gray-100 pb-16">
          <h2 className="text-heading-color text-4xl pt-11 font-bold text-center mb-12">
            OUR BLOG
          </h2>
          <div className="flex flex-col lg:flex-row justify-center items-center">
            <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
              <img loading="lazy w-full" src="./img/blog-1.png" alt="" />
              <div className="p-4">
                <h3 className="font-bold">
                  An Ultimate Digital Signage Solution Guide
                </h3>
                <p>
                  Digital signage attracts 400% more views than static signs. In
                  July...
                </p>
                <a
                  className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                  href=""
                >
                  Read More
                </a>
              </div>
            </div>
            <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
              <img loading="lazy" src="./img/blog-2.png" alt="" />
              <div className="p-4">
                <h3 className="font-bold">
                  Choose the Right Digital Signage Software for Retail Business
                </h3>
                <p>
                  Brick and mortar retail stores have had challenges competing
                  against the ease...
                </p>
                <a
                  className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                  href=""
                >
                  Read More
                </a>
              </div>
            </div>
            <div className="blog flex flex-col justify-center lg:w-3/12 m-6 bg-white hover:shadow-lg">
              <img loading="lazy" src="./img/blog-3.png" alt="" />
              <div className="p-4">
                <h3 className="font-bold">
                  Tips: Screen Sharing & Wireless Presentation on Meetboard
                  Interactive
                </h3>
                <p>
                  Digital signage attracts 400% more views than static signs. In
                  July...
                </p>
                <a
                  className="float-right hover:underline hover:text-main-color mb-6 mt-6"
                  href=""
                >
                  Read More
                </a>
              </div>
            </div>
          </div>
        </section>
        {/* Blog Section End Here */}
        {/* Hardware Section Start Here */}
        <section id="hardware" className="mt-11 mb-11">
          <h2 className="text-heading-color text-4xl pt-11 font-bold text-center">
            HARDWARE
          </h2>
          <div className="flex flex-col lg:flex-row lg:px-28 mt-28 lg:mb-20 justify-center">
            <div className="text-desc-text flex justify-center ">
              <div className="lg:border-r-2 border-dashed px-6">
                <h3 className="text-center xl:text-left   font-bold text-2xl mb-12">
                  Don't Have TVs Yet ?
                </h3>
                <div className="flex flex-col justify-center items-center">
                  <img
                    loading="lazy"
                    src="./img/hardware-tv.png"
                    className=""
                    alt=""
                  />
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-poppins text-xl mt-5">
                      Don't have TVs yet ? <br />
                      <br />
                      Insigna TV with Fire TV Build in $ 234.87 <br />
                      <br />
                      4K content Support all Panelo Apps Offline Playback 8Gb
                      Storage 43'- 50'- 55'- 65'
                    </p>
                    <button className="text-white bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                      <a href="#">Buy Now</a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-desc-text hardware flex justify-center ">
              <div className="lg:border-r-2 border-dashed pl-6 pr-6">
                <h3 className="text-center xl:text-left font-bold text-2xl mb-12">
                  Already Have TVs ?
                </h3>
                <div className="flex flex-col justify-center items-center">
                  <img
                    loading="lazy"
                    src="./img/hardware-remote.png"
                    className=""
                    alt=""
                  />
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-poppins text-xl mt-5">
                      <span className="text-pink-span">Recommended</span>
                      <br />
                      Amazon Fire Stic Lite $ 39.73 <br />
                      <br />
                      Full HD - 1080 Content Support all Panelo Apps Offline
                      Playback 8Gb Storage <br />
                      <br />
                      Need 4K playback? Try Fire Stick
                    </p>
                    <button className="text-white float-left bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                      <a href="#">Buy Now</a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-desc-text hardware flex justify-center ">
              <div className="pl-6 pr-6">
                <h3 className="text-center xl:text-left font-bold text-2xl mb-12">
                  Need Enterprise Class Mass Deployment ?
                </h3>
                <div className="flex flex-col justify-center items-center">
                  <img loading="lazy" src="./img/hardware-router.png" alt="" />
                  <div className="flex flex-col justify-center items-center">
                    <p className="font-poppins text-xl mt-5">
                      Paleno Pre-Configured Player $ 99.73 <br />
                      <br />
                      Pre-Configured WiFi Connected to your account Shipped to
                      your locations Remote Support by Panelo
                    </p>
                    <button className="text-white float-left bg-main-color mt-10 p-3 pl-11 pr-11 mb-20 rounded-md transition .ease-in duration-1000ms hover:bg-orange-dark">
                      <a href="#">Buy Now</a>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="text-center font-bold text-pink-span text-xl mb-9 px-6">
            You only need ONE of the <br /> above devices
          </p>
          <h3 className="text-desc-text text-center font-bold text-2xl  px-6">
            No devices? Try our Webplayer
          </h3>
          <p className="text-center px-6">
            Or Download Panelo Player for your desktop <br /> Full list of
            supported devices
          </p>
        </section>
        {/* Hardware Section End Here */}

        {/* Panelo Real World Section Start Here */}
        <Panelo />

        {/* Banner Contact Us Start Here */}
        <section className="bg-background-color  bg-gradient-to-t">
          <div className="flex flex-col justify-center items-center p-10 lg:p-20">
            <h2 className="text-white font-bold text-3xl lg:text-4xl">
              Contact Us For More Information
            </h2>
            <p className="text-white font-poppins text-xl lg:text-2xl">
              Our Sales Manager will reach you as soon as we can
            </p>
            <button className="text-white mt-12 bg-button-banner p-3 pl-11 pr-11 rounded-md transition .ease-in duration-1000ms hover:bg-red-900">
              <a href="#">Contact Us Now</a>
            </button>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default Home;
